import { Plus, Save, Loader2 } from "lucide-react";

const LABELS = {
  "Only Visit": { add: "Add Visit Record", desc: "General visit notes and prescription for this customer." },
  "Eye Test": { add: "Add Eye Test", desc: "All customer eye test records and reports will be stored securely." },
  "Lens Only": { add: "Add Lens Order", desc: "Lens orders for this customer are logged and tracked here." },
  "Frame Only": { add: "Add Frame Order", desc: "Frame-only orders and prescription for this customer." },
  "Complete Specs": { add: "Add Spectacles", desc: "Full spectacles orders including frame + lens details." },
  "Specs Repair": { add: "Add Repair Ticket", desc: "Repair jobs for this customer are logged for follow-up." },
};

const AddPrescription = ({
  onAdd,
  onSave,
  loading = false,
  visitFor,
}) => {
  const l = LABELS[visitFor] || {
    add: "Add Prescription",
    desc: "All customer prescriptions and uploaded eyewear images will be securely stored in the CRM database.",
  };
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">

        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Customer Management System
          </h2>

          <p className="mt-1 text-gray-500">
            {l.desc}
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row">

          <button
            type="button"
            onClick={onAdd}
            disabled={loading}
            data-testid="add-record-btn"
            className="flex h-12 items-center justify-center gap-2 rounded-xl border border-dashed border-gray-400 px-6 transition hover:border-[#2B1B14] hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            <Plus size={18} />
            {l.add}
          </button>

          <button
            type="button"
            onClick={onSave}
            disabled={loading}
            data-testid="save-customer-btn"
            className="flex h-12 min-w-[170px] items-center justify-center gap-2 rounded-xl bg-[#2B1B14] px-7 text-white transition hover:bg-[#3B241A] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? (
              <>
                <Loader2 size={18} className="animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save size={18} />
                Save Customer
              </>
            )}
          </button>

        </div>

      </div>
    </div>
  );
};

export default AddPrescription;
